import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { HerramientaGeoposicionContent } from './components/HerramientaGeoposicionContent';

export default function HerramientaGeoposicion() {

    return (
        <>
            <MainContent
                component={<HerramientaGeoposicionContent />}
                titulo={'Herramienta de Geoposicionamiento'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
